import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import BusinessContent from '../../components/Pages/Business';

const { displayName } = config;

export default function Business(): React.ReactElement {
  document.title = `${displayName}: Tipping Business`;

  return (
    <Layout>
      <BusinessContent />
    </Layout>
  );
}
